import React,{useEffect,useState} from 'react'
import ProductLanding from './ProductLanding'
import SelectService from '../SelectServices/SelectService'
import Question from "../../Question/Question"
import Footer from "../../Footer/Footer"
import Offer from '../../Offer/Offer'
import { Button } from "react-bootstrap"
import BottomNavbar from '../../BottomNavbar/BottomNavbar'
import Certificate from '../../CertificatePage/Certificate'
import { useLocation } from "react-router-dom";
import { FaThumbsUp, FaThumbsDown } from "react-icons/fa";

export default function PrdouctHome() {
    // ✅ Get state passed from Tabs.jsx
  const location = useLocation();
  const { subcategory } = location.state || {}; // destructure safely

  console.log("Received Subcategory Data:", subcategory);
   const [isMobile, setIsMobile] = useState(false);
      const [feedback, setFeedback] = useState(null);
      const [submitted, setSubmitted] = useState(false);
      const handleFeedback = (type) => {
        setFeedback(type);
        setSubmitted(true);
        // TODO: send to backend API if needed
      };
    
      useEffect(() => {
        const handleResize = () => {
          setIsMobile(window.innerWidth <= 768);
        };
        handleResize(); // initial check
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }, []);
    
  return (
    <div style={{display:"flex",justifyContent:"center",alignItems:"center",flexDirection:"column"}}>
    <ProductLanding/>
    <SelectService subcategory={subcategory}/>
    <Offer/>
    <Question/>
    <br></br>
    <Certificate/>
    <br/>
    <div className="mt-4 p-3 border-top" style={{width:"100%"}}>
        {!submitted ? (
          <>
            <p className="mb-2 fw-bold" style={{ textAlign: "center" }}>
              Was this information helpful?
            </p>
            <div className="d-flex gap-3 flex-wrap justify-content-center">
              <Button
                variant="outline-success"
                className="d-flex align-items-center gap-2"
                onClick={() => handleFeedback("like")}
              >
                <FaThumbsUp /> Yes
              </Button>
              <Button
                variant="outline-danger"
                className="d-flex align-items-center gap-2"
                onClick={() => handleFeedback("dislike")}
              >
                <FaThumbsDown /> No
              </Button>
            </div>
          </>
        ) : (
          <p className="text-success mt-2" style={{ textAlign: "center" }}>
            Thank you for your feedback! 🙏
          </p>
        )}
      </div>
    <br></br> <br></br>
    
    <Footer/>
    <BottomNavbar/>
    </div>
  )
}
